import {
  EdfArenas,
  EdfCampaigns,
  EdfCities,
  EdfCompetitionTypes,
  EdfCountries,
  EdfMatches,
  EdfOpponents,
} from '../directus';
import { TeamMatchHistory, TeamMatch } from '@/components/types';

export default function mapHistoricalDataToTeamMatchHistory(
  data: Array<EdfMatches>,
): TeamMatchHistory {
  const history = {
    competitions: [] as Array<string>,
    cities: [] as Array<string>,
    countries: [] as Array<string>,
    matchs: [] as Array<TeamMatch>,
    opponents: [] as Array<string>,
    years: [] as Array<number>,
  };

  data.forEach(
    ({
      id,
      arena,
      city,
      campaign,
      competition_type,
      date,
      opponent,
      country,
      score_france,
      france_at_home,
      score_opponent,
    }) => {
      const arenaInfo = arena as EdfArenas;
      const campaignInfo = campaign as EdfCampaigns;
      const cityInfo = city as EdfCities;
      const competitionInfo = competition_type as EdfCompetitionTypes;
      const countryInfo = country as EdfCountries;
      const opponentInfo = opponent as EdfOpponents;
      const campaignType = campaignInfo?.competition_type as EdfCompetitionTypes;

      const year = date && date.slice(0, 4);
      // @ts-ignore
      if (year && !history.years.includes(parseInt(year, 10))) {
        // @ts-ignore
        history.years.push(parseInt(year, 10));
      }

      const opponentName = opponentInfo?.name || '';
      if (opponentName && !history.opponents.includes(opponentName)) {
        history.opponents.push(opponentName);
      }

      const competitionName = competitionInfo?.name || campaignType?.name || '';
      if (competitionName && !history.competitions.includes(competitionName)) {
        history.competitions.push(competitionName);
      }

      const countryName = countryInfo?.name || '';
      if (countryName && !history.countries.includes(countryName)) {
        history.countries.push(countryName);
      }

      const cityName = cityInfo?.name || '';
      if (cityName && !history.cities.includes(cityName)) {
        history.cities.push(cityName);
      }

      const scoreFrance = score_france || 0;
      const scoreOpponent = score_opponent || 0;

      const result = france_at_home
        ? `FRANCE-${opponentName} ${scoreFrance}-${scoreOpponent}`
        : `${opponentName}-FRANCE ${scoreOpponent}-${scoreFrance}`;

      let place = arenaInfo?.name || '';
      const cityLabel = cityInfo?.name || '';
      const countryLabel = (country as EdfCountries)?.name || '';

      if (cityLabel && countryLabel) {
        place = `${(city as EdfCities)?.name} - ${(country as EdfCountries)?.name}`;
      }

      history.matchs.push({
        id,
        competition: competitionName,
        date: date || '',
        opponent: opponentName,
        country: countryName,
        // @ts-ignore
        score_france: parseInt(scoreFrance, 10),
        // @ts-ignore
        score_opponent: parseInt(scoreOpponent, 10),
        france_at_home,
        result,
        place,
      });
    },
  );

  return history;
}
